<template>
    <div style="margin: 10px">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <form data-vv-scope="searchForm">
                <v-layout wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select :label="$t('lang.area.name')"
                                  v-model.trim="search.areaId"
                                  v-validate="'required'"
                                  :items="lstArea"
                                  item-text="categoryCode"
                                  item-value="categoryId"
                                  @change="getPondSearchList"
                                  clearable
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select :label="$t('lang.pond.name')"
                                  v-model.trim="search.pondId"
                                  :items="lstPond"
                                  item-text="code"
                                  item-value="pondId"
                                  @change="getCropSearchList"
                                  clearable
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-select
                                :label="$t('lang.crop.name')"
                                v-model.trim="search.cropId"
                                v-validate="'required'"
                                :items="lstCrop"
                                item-text="name"
                                item-value="cropId"
                                @change="changeCrop"
                                clearable
                        />
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <i-datepicker :label="$t('lang.common.fromDate')"
                                      v-model.trim="search.fromDate"
                                      v-validate="'date_before_now'"
                                      :data-vv-as="$t('lang.common.fromDate')"
                                      name="fromDate"
                                      :error-messages="errors.first('fromDate')"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <i-datepicker
                                :label="$t('lang.common.toDate')"
                                v-model.trim="search.toDate"
                                v-validate="'date_before_now'"
                                :data-vv-as="$t('lang.common.toDate')"
                                name="toDate"
                                :error-messages="errors.first('toDate')"
                        />
                    </v-flex>
                </v-layout>
                <div style="text-align: center;">
                    <v-btn color="primary" dark @click="onSearch">
                        <v-icon dark left>search</v-icon>
                        {{$t('lang.common.search')}}
                    </v-btn>
                    <v-btn color="red" dark @click="createNew">
                        <v-icon dark left>add</v-icon>
                        {{$t('lang.common.add')}}
                    </v-btn>
                </div>
            </form>
            <v-card-text>
                <v-data-table :items="lstItem" :total-items="totalRows" class="lstTable"
                              @update:pagination="onPaging"
                              :pagination.sync="pagination"
                >
                    <template slot="headers">
                        <tr>
                            <th width="100px">
                                {{$t("lang.envMeasure.date") }}
                            </th>
                            <th width="20px">Tuổi tôm</th>
                            <th width="20px">
                                {{$t("lang.envMeasure.session")}}
                            </th>
                            <th v-for="item in lstIndex" width="20px">
                                {{$t(item.envName)}} ({{item.unitType}})
                            </th>
                            <th width="20px">Size tôm (con/kg)</th>
                            <th width="20px">Tỉ lệ tôm sống (%)</th>
                            <th width="20px">G</th>
                            <th width="50px">
                                {{$t("lang.envMeasure.note")}}
                            </th>
                            <th width="50px">
                                {{$t("lang.common.actions")}}
                            </th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="data">
                        <tr>
                            <td rowspan="2">{{data.item.measureDate | formatDate}}</td>
                            <td rowspan="2">
                                {{shrimpAgeByDate(crop,data.item.measureDate)}}
                            </td>
                            <td>{{$t('lang.envMeasure.am')}}</td>
                            <td v-for="item in lstIndex" style="text-align: right"
                                :class="calculateClass(item.envId,data.item.amIdx[item.envId])">
                                {{data.item.amIdx[item.envId]}}
                            </td>
                            <td style="text-align: right">
                                {{data.item.amIdx["shrimpSize"]}}

                            </td>
                            <td style="text-align: right">
                                {{data.item.amIdx["livePercent"]}}

                            </td>
                            <td>{{data.item.amIdx.g}}</td>
                            <td rowspan="2">{{data.item.notes}}</td>
                            <td rowspan="2" style="text-align: center">
                                <v-btn depressed outline icon fab dark color="primary" small
                                       @click="editItem(data.item)"
                                       title="edit">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn depressed outline icon fab dark color="info" small
                                       @click="copyItem(data.item)"
                                       title="copy">
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn depressed outline icon fab dark color="pink" small @click="deleteItem(data.item)"
                                       title="delete">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('lang.envMeasure.pm')}}</td>
                            <td v-for="item in lstIndex" style="text-align: right"
                                :class="calculateClass(item.envId,data.item.pmIdx[item.envId])">
                                {{data.item.pmIdx[item.envId]}}
                            </td>
                            <td style="text-align: right">
                                {{data.item.pmIdx["shrimpSize"]}}

                            </td>
                            <td style="text-align: right">
                                {{data.item.pmIdx["livePercent"]}}
                            </td>
                            <td>{{data.item.pmIdx.g}}</td>
                        </tr>
                    </template>
                    <template slot="no-data">
                        <tr>
                            <td :colspan="lstIndex.length+7" style="text-align: center">
                                {{$t("lang.$vuetify.noDataText")}}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <div class="G2 indicator">G2</div>
                <div class="G3 indicator">G3</div>
            </v-card-text>
        </v-card>
        <v-dialog v-model="createDlg" width="1000px" persistent>
            <v-form data-vv-scope="createForm">
                <v-card>
                    <div class="headline dialog-header">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title style="padding-left: 10px">{{
                                $t(formName)
                                }}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-btn
                                @click="onCancel"
                                icon
                                style="position: absolute; right: 10px; top: 10px; color: #fff"
                        >
                            <v-icon>cancel</v-icon>
                        </v-btn>
                    </div>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                                <v-select :label="$t('lang.area.name')"
                                          v-model.trim="createItem.areaId"
                                          v-validate="'required'"
                                          name="createAreaId"
                                          :items="lstArea"
                                          item-text="categoryCode"
                                          item-value="categoryId"
                                          @change="getPondCreateList"
                                          :data-vv-as="$t('lang.area.name')"
                                          :error-messages="errors.first('createAreaId')"/>

                            </v-flex>
                            <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                                <v-select :label="$t('lang.pond.name')"
                                          v-model.trim="createItem.pondId"
                                          v-validate="'required'"
                                          name="createPondId"
                                          :items="lstPondCreate"
                                          item-text="code"
                                          item-value="pondId"
                                          @change="getCropCreateList"
                                          :data-vv-as="$t('lang.pond.name')"
                                          clearable
                                          :error-messages="errors.first('createPondId')"/>
                            </v-flex>
                            <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                                <v-select
                                        :label="$t('lang.crop.name')"
                                        v-model.trim="createItem.cropId"
                                        name="createCropId"
                                        v-validate="'required'"
                                        :items="lstCropCreate"
                                        item-text="name"
                                        item-value="cropId"
                                        :data-vv-as="$t('lang.crop.name')"
                                        :error-messages="errors.first('createCropId')"/>

                            </v-flex>
                        </v-layout>
                        <div style="width: 100%;overflow-x: auto">
                            <table class="lstTable">
                                <tr>
                                    <th width="20%">
                                        {{$t("lang.envMeasure.date")}}
                                    </th>
                                    <th width="5%">
                                        {{$t("lang.envMeasure.session")}}
                                    </th>
                                    <th v-for="item in lstIndex" width="5%">
                                        {{$t(item.envName)}} ({{item.unitType}})
                                    </th>
                                    <th width="5%">Size tôm (con/kg)</th>
                                    <th width="5%">Tỉ lệ tôm sống(%)</th>
                                    <th width="10%">
                                        {{$t("lang.envMeasure.note")}}
                                    </th>
                                </tr>
                                <tr>
                                    <td rowspan="2">
                                        <i-datepicker :label="$t('lang.envMeasure.date')"
                                                      v-model="createItem.measureDate"
                                                      v-validate="'required|date_before_now'"
                                                      :data-vv-as="$t('lang.envMeasure.date')"
                                                      name="measureDate"
                                                      :error-messages="errors.first('measureDate')"
                                                      @change="onSearchCreate"
                                        />
                                    </td>
                                    <td>{{$t('lang.envMeasure.am')}}</td>
                                    <td v-for="item in lstIndex">
                                        <input type="number" v-model="createItem.amIdx[item.envId]"
                                               @change="updatePm(item.envId)" @keydown="keyProcess"
                                               :id="'am_'+item.envId" step="0"/>
                                    </td>
                                    <td>
                                        <input type="number" v-model="createItem.amIdx['shrimpSize']"
                                               @change="updatePm('shrimpSize')" @keydown="keyProcess"
                                               id="am_shrimpSize" step="0"/>

                                    </td>
                                    <td>
                                        <input type="number" v-model="createItem.amIdx['livePercent']"
                                               @change="updatePm('livePercent')" @keydown="keyProcess"
                                               id="am_livePercent" step="0"/>
                                    </td>
                                    <td rowspan="2">
                                        <v-text-field v-model="createItem.notes"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('lang.envMeasure.pm')}}</td>
                                    <td v-for="item in lstIndex">
                                        <input type="number" v-model="createItem.pmIdx[item.envId]"
                                               :id="'pm_'+item.envId" @keydown="keyProcess" step="0"/>
                                    </td>
                                    <td>
                                        <input type="number" v-model="createItem.pmIdx['shrimpSize']"
                                               @keydown="keyProcess"
                                               id="pm_shrimpSize" step="0"/>

                                    </td>
                                    <td>
                                        <input type="number" v-model="createItem.pmIdx['livePercent']"
                                               @keydown="keyProcess"
                                               id="pm_livePercent" step="0"/>
                                    </td>

                                </tr>
                            </table>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click.once="onSave" :key="saveSession">
                            {{ $t("lang.common.save") }}
                        </v-btn>
                        <v-btn color="error" @click="onCancel">
                            {{ $t("lang.common.cancel") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    import IDatepicker from "../../../components/form/DatePicker";
    import {message} from "../../../shared/message";
    import moment from "moment";

    export default {
        name: "env-measure",
        components: {IDatepicker},
        data: () => {
            return {
                formName: "Chỉ số môi trường",
                envItem: null,
                createDlg: false,
                visibleEnvDialog: false,
                lstIndex: [],
                lstPond: [],
                lstPondCreate: [],
                lstArea: [],
                lstCrop: [],
                crop: null,
                lstCropCreate: [],
                lstItem: [],
                search: {
                    fromDate: (new Date()).setDate(new Date().getDate() - 7),
                    toDate: new Date()
                },
                createItem: {
                    measureDate: null,
                    pondId: null,
                    areaId: null,
                    cropId: null,
                    am: null,
                    pm: null,
                    amIdx: {},
                    pmIdx: {},
                    notes: null
                },
                g: null,
                saveSession:new Date().getTime(),
                totalRows: 0,
                pagination: {
                    rowsPerPage: 10,
                    page: 1,
                    totalItems: 0
                },
            };
        },

        created() {
            this.getEnvIndex();
            this.getArea();
        },

        methods: {
            keyProcess($event) {
                const inputs = Array.from($event.target.form.querySelectorAll('input[type="number"]'));
                const index = inputs.indexOf($event.target);
                let id = $event.target.getAttribute("id");
                if (id.indexOf("am") >= 0) {
                    id = id.replace("am", "pm");
                } else {
                    id = id.replace("pm", "am");
                }
                switch ($event.keyCode) {
                    case 37:
                        // left
                        if (index > 0) {
                            inputs[index - 1].focus();
                        }
                        $event.preventDefault();
                        break;
                    case 38:
                        // up
                        document.getElementById(id).focus();
                        $event.preventDefault();
                        break;
                    case 13:
                        if (index < inputs.length - 1) {
                            inputs[index + 1].focus();
                        }
                        $event.preventDefault();
                        break;
                    case 39:
                        //right
                        if (index < inputs.length - 1) {
                            inputs[index + 1].focus();
                        }
                        $event.preventDefault();
                        break;
                    case 40:
                        //down
                        document.getElementById(id).focus();
                        $event.preventDefault();
                        break;
                }

            },

            updatePm(evnIdx) {
                if (this.createItem.pmIdx[evnIdx] == undefined || this.createItem.pmIdx[evnIdx] == null || this.createItem.pmIdx[evnIdx] == "") {
                    this.createItem.pmIdx[evnIdx] = this.createItem.amIdx[evnIdx];
                    this.$forceUpdate();
                }
            },

            shrimpAgeByDate(crop, calculateDate) {
                let shrimpAge = 0;
                let dropDate = '';
                if (parseInt(crop.pondParent) > 0 && crop.dropDateParent != '' && crop.dropDateParent != null) {
                    dropDate = moment(String(crop.dropDateParent));
                } else if (crop.dropDate != '' && crop.dropDate != null) {
                    dropDate = moment(String(crop.dropDate));
                }
                console.log(dropDate);
                if (dropDate != '') {
                    let calculateDateMM = moment(calculateDate);
                    let endDate = moment(calculateDate);
                    if (crop.endDate) {
                        endDate = moment(String(crop.endDate));
                        if (endDate > calculateDateMM) endDate = calculateDateMM;
                    }
                    if (endDate > dropDate) {
                        let dates = endDate.diff(dropDate, "days");
                        if (dates >= 0) {
                            shrimpAge = dates;
                        }
                    }
                }
                return shrimpAge;

            },

            getG() {
                if (this.search.areaId == undefined || this.search.areaId == null) {
                    message.error("Chưa chọn khu");
                    return;
                }
                axios.post(
                    process.env.VUE_APP_API_URL + "/gindex/search", this.search
                ).then(
                    (data) => {
                        if (data.items && data.items.length > 0) {
                            this.g = data.items[0];
                            console.log(this.g);
                            if (this.g.g1 != undefined && this.g.g1 != null) {
                                this.g.g1Index = JSON.parse(this.g.g1);
                            } else {
                                this.g.g1Index = {};
                            }

                            if (this.g.g2 != undefined && this.g.g2 != null) {
                                this.g.g2Index = JSON.parse(this.g.g2);
                            } else {
                                this.g.g2Index = {};
                            }
                            //
                            //
                            //
                            for (let i = 0; i < this.lstIndex.length; i++) {
                                if (this.g.g1Index[this.lstIndex[i].envId] == undefined || this.g.g1Index[this.lstIndex[i].envId] == null) {
                                    this.g.g1Index[this.lstIndex[i].envId] = {};
                                }
                                if (this.g.g2Index[this.lstIndex[i].envId] == undefined || this.g.g2Index[this.lstIndex[i].envId] == null) {
                                    this.g.g2Index[this.lstIndex[i].envId] = {};
                                }
                            }
                        }
                    }
                );
            },

            checkInRange(number, min, max) {
                if (isNaN(number)) {
                    return false;
                }
                if((min == undefined || min == null || min == "" || isNaN(min)) && (max == undefined || max == null || max == "" || isNaN(max))){
                    return false;
                }
                if (min != undefined && min != null && min !== "") {
                    if (min > number) {
                        return false;
                    }
                }
                if (max != undefined && max != null && max !== "") {
                    if (max < number) {
                        return false;
                    }
                }
                return true;

            },

            calculateClass(id, number) {
                if (number == undefined || number == null || number == "" || isNaN(number)) {
                    return "";
                }
                let g1 = this.g.g1Index[id];
                let g2 = this.g.g2Index[id];
                let idx = parseFloat(number);
                if (this.checkInRange(idx, parseFloat(g1.min), parseFloat(g1.max))) {
                    return "";
                } else if (
                    this.checkInRange(idx, parseFloat(g2.min1), parseFloat(g2.max1))
                    || this.checkInRange(idx, parseFloat(g2.min2), parseFloat(g2.max2)
                    )) {
                    return "G2";
                } else {
                    return "G3";
                }
            },

            calculateG(index) {
                if (this.g == null) {
                    return;
                }
                if (index == null) {
                    return;
                }
                let gindex = "G1";
                for (let i = 0; i < this.lstIndex.length; i++) {
                    let id = this.lstIndex[i].envId;
                    if (index[id] == undefined || index[id] == null || index[id] === "" || isNaN(index[id])) {
                        continue;
                    }
                    let g1 = this.g.g1Index[id];
                    let g2 = this.g.g2Index[id];
                    console.log(g1);
                    console.log(g2);
                    let idx = parseFloat(index[id]);
                    if (this.checkInRange(idx, parseFloat(g1.min), parseFloat(g1.max))) {
                        continue;
                    } else if (
                        this.checkInRange(idx, parseFloat(g2.min1), parseFloat(g2.max1))
                        || this.checkInRange(idx, parseFloat(g2.min2), parseFloat(g2.max2)
                        )) {
                        gindex = "G2";
                    } else {
                        console.log("---G3---")
                        console.log(this.lstIndex[i]);
                        console.log(idx);
                        gindex = "G3";
                        break;
                    }

                }
                return gindex;

            },

            changeCrop() {
                this.crop = this.lstCrop.filter(
                    item => {
                        return item.cropId == this.search.cropId;
                    }
                )[0];
                this.onSearch();
            },

            getEnvIndex() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/envIndex/search?pageSize=-1&page=0", {}
                ).then(
                    (data) => {
                        this.lstIndex = data.items;
                    }
                );
            },

            getArea() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/myArea"
                ).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstArea = data;
                        }
                    }
                );
            },

            getPondSearchList() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/pond/search?&pageSize=-1&page=1", {areaId: this.search.areaId,status:1}
                ).then(
                    (data) => {
                        console.log(data);
                        if (data.count > 0) {
                            this.lstPond = data.items;
                        }
                    }
                );
                this.getCropSearchList();
                this.getG();
            },

            getPondCreateList() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/pond/search?&pageSize=-1&page=1", {areaId: this.createItem.areaId}
                ).then(
                    (data) => {
                        //console.log(data);
                        if (data.count > 0) {
                            this.lstPondCreate = data.items;
                        }
                    }
                );
                this.getCropCreateList();
            },

            getCropSearchList() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1&orderBy=asc", {
                        pondAreaId: this.search.areaId,
                        pondId: this.search.pondId,
                        status: 1
                    }
                ).then(
                    (data) => {
                        if (data.items) {
                            this.lstCrop = data.items;
                            this.lstCropCreate = data.items;
                        }
                    }
                );
            },

            getCropCreateList() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1&orderBy=asc", {
                        pondAreaId: this.createItem.areaId,
                        pondId: this.createItem.pondId,
                        status: 1
                    }
                ).then(
                    (data) => {
                        if (data.items) {
                            this.lstCropCreate = data.items;
                        }
                    }
                );

            },

            onSearch() {

                if (this.search.areaId == undefined || this.search.areaId == null) {
                    message.error("Chưa chọn khu");
                    return;
                }
                if (this.search.cropId == undefined || this.search.cropId == null) {
                    message.error("Chưa chọn vụ");
                    return;
                }
                axios.post(
                    process.env.VUE_APP_API_URL + "/envMeasure/search?pageSize=" + this.pagination.rowsPerPage + "&page=" + this.pagination.page, this.search
                ).then(
                    (data) => {
                        if (data.items) {
                            this.lstItem = data.items;
                            this.totalRows = data.count;
                            for (let i = 0; i < this.lstItem.length; i++) {
                                if (this.lstItem[i].am != undefined && this.lstItem[i].am != null) {
                                    this.lstItem[i].amIdx = JSON.parse(this.lstItem[i].am);
                                } else {
                                    this.lstItem[i].amIdx = {};
                                }

                                if (this.lstItem[i].pm != undefined && this.lstItem[i].pm != null) {
                                    this.lstItem[i].pmIdx = JSON.parse(this.lstItem[i].pm);
                                } else {
                                    this.lstItem[i].pmIdx = {};
                                }
                            }
                            console.log(this.lstItem);
                        }
                    }
                );
            },

            onSearchCreate() {
                console.log("sdfdsfdsf");
                let searchItem = {
                    pondId: this.createItem.pondId,
                    cropId: this.createItem.cropId,
                    measureDate: this.createItem.measureDate
                };
                axios.post(
                    process.env.VUE_APP_API_URL + "/envMeasure/search?pageSize=-1&page=-1&orderBy=asc", searchItem
                ).then(
                    (data) => {
                        if (data.count > 0) {
                            if (confirm("Chỉ số môi trường của ngày này đã được khai báo, bạn có muốn sửa chỉ số của ngày này")) {
                                this.createItem = data.items[0];
                                this.createItem.areaId = this.search.areaId;
                                if (this.createItem.am != undefined && this.createItem.am != null) {
                                    this.createItem.amIdx = JSON.parse(this.createItem.am);
                                } else {
                                    this.createItem.amIdx = {};
                                }

                                if (this.createItem.pm != undefined && this.createItem.pm != null) {
                                    this.createItem.pmIdx = JSON.parse(this.createItem.pm);
                                } else {
                                    this.createItem.pmIdx = {};
                                }

                            } else {
                                this.createItem.measureDate = "";
                            }
                        }
                    }
                );
            },

            onPaging: function (page) {
                this.pagination = page;
                this.onSearch();
            },

            refreshCreatePondValue(){
                console.log(this.createItem);
                if(this.createItem.cropId != null && this.createItem.pondId ==null){
                    for(let i=0;i<this.lstCropCreate.length;i++){
                        if(this.lstCropCreate[i].cropId == this.createItem.cropId){
                            this.createItem.pondId = this.lstCropCreate[i].pondId;
                            break;
                        }
                    }
                }
            },

            createNew() {
                this.lstPondCreate = this.lstPond;
                this.lstCropCreate = this.lstCrop;
                this.createItem = {
                    measureDate: null,
                    areaId: this.search.areaId,
                    pondId: this.search.pondId,
                    cropId: this.search.cropId,
                    am: null,
                    pm: null,
                    amIdx: {},
                    pmIdx: {},
                    notes: null
                };
                this.refreshCreatePondValue();
                this.createDlg = true;
            },

            onCancel() {
                this.createDlg = false;
                this.onSearch();
            },

            onSave() {
                this.$validator.validateAll("createForm").then(valid => {
                    if (valid) {
                        this.createItem.amIdx.g = this.calculateG(this.createItem.amIdx);
                        this.createItem.pmIdx.g = this.calculateG(this.createItem.pmIdx);
                        this.createItem.am = JSON.stringify(this.createItem.amIdx);
                        this.createItem.pm = JSON.stringify(this.createItem.pmIdx);
                        console.log(this.createItem);
                        axios.post(process.env.VUE_APP_API_URL + "/envMeasure/save", this.createItem).then(
                            data => {
                                if (data.success) {
                                    message.success(this.$t("lang.common.save_success"));
                                    this.onCancel();
                                } else {
                                    message.error(data.description);
                                }
                                this.saveSession = new Date().getTime();
                            }
                        )
                    } else {
                        message.error("Thông tin nhập chưa chính xác")
                        this.saveSession = new Date().getTime();
                    }
                })

            },

            editItem(item) {
                const measureDate = moment(String(item.measureDate)).format("YYYY-MM-DD");
                if (measureDate >= moment().format("YYYY-MM-DD")) {
                    this.createItem = item;
                    this.createItem.areaId = this.search.areaId;
                    this.createItem.pondId = this.search.pondId;
                    this.getPondCreateList();
                    this.refreshCreatePondValue();
                    this.createDlg = true;
                } else {
                    message.error('Ngày này không được sửa.');
                }
            },

            copyItem(item) {
                this.createItem = {
                    envMeasureId: null,
                    measureDate: null,
                    cropId: item.cropId,
                    am: item.cropId,
                    amIdx: item.amIdx,
                    pm: item.cropId,
                    pmIdx: item.pmIdx,
                    notes: item.notes
                };
                this.createItem.areaId = this.search.areaId;
                this.createItem.pondId = this.search.pondId;
                this.getPondCreateList();
                this.refreshCreatePondValue();
                this.createDlg = true;
            },

            deleteItem(item) {
                if (confirm(this.$t("lang.common.deleteConfirm"))) {
                    axios.post(process.env.VUE_APP_API_URL + "/envMeasure/delete", item).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.delete_success"));
                                this.onSearch();
                            } else {
                                message.error("Xóa không thành công")
                            }
                        }
                    )

                }
            },
        },

        destroyed() {
        },
    };
</script>

<style>
    .indicator {
        margin: 5px 5px 5px 0px;
        padding: 5px;
        display: inline-block;
        border: 1px solid gray;
        width: fit-content;
    }

    .G2 {
        background-color: gold;
    }

    .G3 {
        background-color: crimson;
    }
</style>